import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { EXTENDED_GRAPHQL_TIMEOUT_MS } from '@core/services/constants';
import { useMemo } from 'react';

import { GET_COMPREHENSIVE_ANALYTICS } from '../graphql/queries/getComprehensiveAnalytics';

interface UseGetComprehensiveAnalyticsParams {
  communityId: string;
  fromDate: string;
  toDate: string;
  skip?: boolean;
}

export function useGetComprehensiveAnalytics({ communityId, fromDate, toDate, skip = false }: UseGetComprehensiveAnalyticsParams) {
  const { data, loading, error, refetch } = useQuery(GET_COMPREHENSIVE_ANALYTICS, {
    variables: {
      communityId,
      fromDate,
      toDate,
    },
    skip,
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    context: { timeout: EXTENDED_GRAPHQL_TIMEOUT_MS },
  });

  const comprehensiveAnalytics = useMemo(() => data?.community?.comprehensiveAnalytics || null, [data]);

  // Transform GraphQL errors to domain errors for standardized messaging
  const errors: DomainError[] = useMemo(() => (error ? transformErrors(error) : []), [error]);

  return {
    comprehensiveAnalytics,
    isLoading: loading,
    errors,
    refetch,
  };
}
